export default __webpack_public_path__ + "static/media/close.c3ce72f7.png";